import Sidebar from '@assets/sidebar.svg';
import PageLoading from '@components/PageLoading/PageLoading';

import AuthModule from '@modules/AuthModule';
import useAuth from '@modules/AuthModule/hooks/useAuth';
import {
  BodyText,
  Button,
  Headline,
  Icon,
  StackItem,
} from '@servicetitan/design-system';
import { useNavigate } from 'react-router-dom';

import { ContactCenterLogo } from '@components/ContactCenterLogo';
import { LoadingIndicator } from '@components/LoadingIndicator';
import { signInLocators } from '@locators/signin';
import { NO_ACTIVE_CONTRACT } from '@modules/AuthModule/constants/auth';
import PaywallComponent from './components/PaywallComponent/PaywallComponent';
import {
  NoWrapText,
  STLogo,
  SidebarContainer,
  SigninPageContainer,
  SigninPageContent,
  WelcomeContainer,
} from './SigninPage.styled';

export const SigninPage = () => {
  const navigate = useNavigate();
  const { loading, error, loadingState, signedIn } = useAuth();
  const hideSigninPage = !loading && loadingState === 'none' && signedIn;

  const handleEnterpriseHubSignin = async () => {
    await AuthModule.signin('eh');
    navigate('/');
  };

  if (loading) {
    if (loadingState === 'signin') {
      return <PageLoading showLogo />;
    } else {
      return <PageLoading />;
    }
  }

  const showPaywall = error === NO_ACTIVE_CONTRACT;

  return !hideSigninPage ? (
    <SigninPageContainer>
      <SidebarContainer>
        <Sidebar className='h-100vh' />
      </SidebarContainer>
      <SigninPageContent>
        <STLogo />
        {showPaywall && <PaywallComponent />}
        {!showPaywall && (
          <WelcomeContainer direction='column' spacing='3'>
            {!error && (
              <>
                <StackItem>
                  <Headline>Welcome back to</Headline>
                  <ContactCenterLogo />
                </StackItem>
                <StackItem>
                  <NoWrapText>Sign in using your credentials.</NoWrapText>
                </StackItem>
              </>
            )}
            {error && (
              <>
                <StackItem>
                  <ContactCenterLogo />
                </StackItem>
                <StackItem>
                  <BodyText bold>Unable to sign in</BodyText>
                  <BodyText className='m-t-half'>
                    Check your internet connection and try again.
                  </BodyText>
                  <BodyText className='m-t-half c-red'>{error}</BodyText>
                </StackItem>
              </>
            )}
            <StackItem>
              <Button
                color='primary'
                fill='outline'
                onClick={handleEnterpriseHubSignin}
                size='large'
                width='full'
                id={signInLocators.ehSignInButton}
              >
                Sign in with Enterprise Hub
                <Icon name='arrow_forward' />
              </Button>
            </StackItem>
          </WelcomeContainer>
        )}
        <LoadingIndicator title='Opening [SSO Provider]' show={loading} />
      </SigninPageContent>
    </SigninPageContainer>
  ) : null;
};

export default SigninPage;
